import React, { useEffect } from "react";
import { Box, Container, Paper, useTheme } from "@mui/material";
import { getBanner } from "../api/authAPI";

export default function AuthLayout({ children }) {
  const theme = useTheme();
  const [bannerImage, setBannerImage] = React.useState(null);

  const fetchBanner = async () => {
    try {
      const res = await getBanner();
      console.log(res, "get banner response");
      if (res.success) {
        setBannerImage(res.data?.bannerImage);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        background: theme.palette.mode === "dark"
          ? theme.palette.background.default
          : "#FFFFFF", // left side background
      }}
    >
      {/* Left side (empty) */}
      <Box
        sx={{
          flex: 1,
          position: "relative",
          zIndex: 1,
          overflow: "visible",

          display: { xs: "none", md: "block" }, // hide on mobile
        }}
      >
        {bannerImage && (
          <img
            src={bannerImage}
            alt="Authentication Illustration"
            style={{
              width: "100%",
              height: "100vh",
              objectFit: "cover",
            }}
          />
        )}
      </Box>


      {/* Right panel */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" }, // 👈 full width on mobile
          height: "100vh",

          borderTopLeftRadius: { xs: 0, md: "30px" },
          borderBottomLeftRadius: { xs: 0, md: "30px" },

          background:
            theme.palette.mode === "dark"
              ? theme.palette.background.paper
              : "#F5F7FB",

          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",

          ml: { xs: 0, md: "-30px" }, // 👈 remove overlap on mobile
          zIndex: 2,
        }}
      >


        {/* Arc SVG behind auth card */}
        <Box
          component="img"
          src="/arc.svg"
          alt=""
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            height: "70%",
            opacity: theme.palette.mode === "dark" ? 0.15 : 0.35,
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        {/* Auth card */}
        <Container
          maxWidth="sm"
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Paper
            elevation={theme.palette.mode === "dark" ? 10 : 4}
            sx={{
              width: "100%",
              borderRadius: 3,
              p: 4,
              bgcolor: theme.palette.background.paper,
              boxShadow:
                theme.palette.mode === "dark"
                  ? "0 25px 50px rgba(0,0,0,0.6)"
                  : "0 25px 50px rgba(0,0,0,0.15)",
            }}
          >
            {children}
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
